import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { API_URL, scroll, getValFromLS, setValToLS } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Checkbox from "../components/Checkbox";
import InputFile from "../components/InputFile";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const CharityRegDocuments = () => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		id: "0",
	});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();

	useEffect(() => {
		scroll();
		init(getValFromLS("crId") || "0");
	}, []);

	const init = async (id) => {
		const url = new URL(`${API_URL}/crDocumentsInit`);
		const params = {
			id,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json) {
				setNames({ ...json });
				setAlert({});
				if (json.resp === 0 && getValFromLS("crId")) {
					setValToLS("crId", "");
				}
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/crDocuments`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (
				key === "acknowledge" ||
				key === "returning" ||
				key === "logo" ||
				key === "w9"
			) {
				data.append(key, value ? "1" : "0");
			} else {
				data.append(key, value);
			}
		});

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setValToLS("crId", json.id);
				history.push("/registration");
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<div id="full-column">
			<Hdg section="Registration" />
			<>
				{alert.type ? (
					<Alert data={alert} />
				) : (
					<>
						<h3>
							<i className="fa fa-upload" /> &nbsp;Upload Documents
						</h3>

						<p>
							Please have your current W9 (dated March 2024 in top left corner)
							and your organization’s logo in JPG or PNG formats ready to
							upload. Should you have any questions, please contact{" "}
							<a href="mailto:stephanie@valerotexasopen.com">
								Stephanie@ValeroTexasOpen.com
							</a>{" "}
							or at 210.345.3839.
						</p>

						{/* not needed !names.returning && (
							<div
								className="alert well-sm alert-warning"
								role="alert"
								style={{
									marginTop: "15px",
									marginBottom: "15px",
									fontWeight: "bolder",
								}}
							>
								As a new charity registering this year, please also download and
								complete the Charitable Organization Setup Form below.
							</div>
						)*/}

						{!names.returning && (
							<div
								className="alert well-sm alert-warning"
								role="alert"
								style={{
									marginTop: "15px",
									marginBottom: "15px",
									fontWeight: "bolder",
								}}
							>
								Please upload your logo and the current W9 (dated March 2024 in
								top left corner).
							</div>
						)}

						<form
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<div className="form-group checkbox" style={{ marginTop: "0" }}>
								<Checkbox
									name="acknowledge"
									label={
										names.returning
											? "Check to use my uploaded logo from last year"
											: "I will email Stephanie my logo and W9 at a later date"
									}
									checked={false}
									click={handleUpdate}
								/>
							</div>

							{names.returning && (
								<table className="approved">
									<thead>
										<tr>
											<th className="left" style={{ padding: "10px" }}>
												Document
											</th>
											<th style={{ padding: "10px 5px" }}>Status</th>
										</tr>
									</thead>
									<tbody style={{ background: "white" }}>
										{["logo", "w9", "letter501c3"]
											.filter((doc) => doc !== "letter501c3") // not needed
											.map((item, index) => {
												return (
													<tr key={index}>
														<td className="left" style={{ padding: "10px" }}>
															{item === "logo"
																? "Logo"
																: item === "w9"
																? "W9"
																: "501(c)(3) Letter"}
														</td>
														<td style={{ padding: "10px 5px" }}>
															<i
																className={
																	names[item]
																		? "fa fa-check fa-lg success"
																		: "fa fa-times fa-lg error"
																}
															/>
														</td>
													</tr>
												);
											})}
									</tbody>
								</table>
							)}

							<div className="form-group">
								<InputFile
									name="logoNew"
									label="Charity Logo"
									reqd={false}
									value={names.logoNew || ""}
									update={handleUpdate}
									errors={errors}
								/>

								{names.returning ? (
									<div className="empty:" />
								) : (
									<InputFile
										name="w9New"
										label="Completed & Signed W9 (<a href='https://vto.qnmcdn.com/championsforecharity/api/assets/w9.pdf' target='_blank' rel='noopener'>Download W9</a>)"
										reqd={false}
										value={names.w9New || ""}
										update={handleUpdate}
										errors={errors}
									/>
								)}

								{/* not needed !names.returning ? (
									<InputFile
										name="form"
										label="Charitable Organization Setup Form (<a href='https://vto.qnmcdn.com/championsforecharity/api/assets/CharitableOrganizationSetupForm.pdf?v1' target='_blank' rel='noopener'>Download Form</a>)"
										reqd={false}
										value={names.form || ""}
										update={handleUpdate}
										errors={errors}
										note="Required for new charities, please upload the completed form."
									/>
								) : (
									<div className="empty" />
								)*/}
							</div>

							{/* not needed <div className="form-group">
								<InputFile
									name="letter501c3"
									label="501(c)(3) Letter"
									reqd={false}
									value={names.letter501c3 || ""}
									update={handleUpdate}
									errors={errors}
								/>
							</div>*/}

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit
										path="/registration"
										left="Back"
										submit="Submit Documents"
									/>
								</div>
							</div>
						</form>
					</>
				)}
			</>
		</div>
	);
};

export default CharityRegDocuments;
